import ScheduleFrequency from '@/models/Shared/ScheduleFrequency';

export default (scheduleFrequency: ScheduleFrequency) => {
    let returnVal = "Undefined";
    switch (scheduleFrequency) {
        case ScheduleFrequency.Once:
            returnVal = "Once"
            break;
        case ScheduleFrequency.Daily:
            returnVal = "Daily"
            break;
        case ScheduleFrequency.Weekly:
            returnVal = "Weekly"
            break;
        case ScheduleFrequency.TwoWeekly:
            returnVal = "Two Weekly"
            break;
        case ScheduleFrequency.Monthly:
            returnVal = "Monthly"
            break;
        case ScheduleFrequency.Quarterly:
            returnVal = "Quarterly"
            break;
        case ScheduleFrequency.Annually:
            returnVal = "Annually"
            break;
    }
    return returnVal;
}